import { FormatTypes } from '../../../../../constants/templateDictionaries';
// import store from '../../../../../store';
import {
  Black,
  atsChipBG,
  msWordChipBG,
  white,
} from '../../../../../styling/theme';

export const filters = {
  SKILL_RATINGS: 'SKILL_RATINGS',
  MULTI_COLUMN: 'MULTI_COLUMN',
  SINGLE_COLUMN: 'SINGLE_COLUMN',
  DOCX: 'DOCX',
  IMAGES: 'IMAGES',
};

export const templateEnums = {
  PDF: 'PDF',
  DOCX: 'DOCX',
  ATS_FRIENDLY: 'ATS-Friendly',
  RESUME: 'Resume',
};

const { SKILL_RATINGS, MULTI_COLUMN, SINGLE_COLUMN, DOCX, IMAGES } = filters;

export const Attractive = {
  type: 'Resume',
  name: 'Attractive',
  description: 'Steals attention at first look with two columns',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Agricultural-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Agricultural-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'free',
  default: true,
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SKILL_RATINGS, MULTI_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#27AE60',
      text: 'Free',
    },
    {
      color: '#FFFFFF',
      bgColor: '#F2994A',
      text: 'Ratings Incl.',
    },
  ],
};

export const Basic = {
  type: 'Resume',
  name: 'Basic',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/basic-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/basic-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};

export const Elegant = {
  type: 'Resume',
  name: 'Elegant',
  description: 'Dual column eye-catchy elegant design',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Elegant-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Elegant-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SKILL_RATINGS, MULTI_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#F2994A',
      text: 'Ratings Incl.',
    },
  ],
};

export const Emblem = {
  type: 'Resume',
  name: 'Emblem',
  description: 'This is emblem',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Emblem-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Emblem-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, IMAGES],
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};

export const Exemplary = {
  type: 'Resume',
  name: 'Exemplary',
  description: 'This is exemplary',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Exemplary-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Exemplary-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [MULTI_COLUMN, SKILL_RATINGS, IMAGES],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#F2994A',
      text: 'Ratings Incl.',
    },
  ],
};

export const Gradient = {
  type: 'Resume',
  name: 'Gradient',
  description: 'This is gradient',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Gradient-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Gradient-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'free',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN],
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#27AE60',
      text: 'Free',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Orion = {
  type: 'Resume',
  name: 'Orion',
  description: 'This is Orion',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Orion-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Orion-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN],
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Proxima = {
  type: 'Resume',
  name: 'Proxima',
  description: 'This is Proxima',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Proxima-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Proxima-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Falcon = {
  type: 'Resume',
  name: 'Falcon',
  description: 'This is Falcon',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Falcon-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Falcon-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Techie = {
  type: 'Resume',
  name: 'Techie',
  description: 'This is Techie',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Techie-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Techie-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Streak = {
  type: 'Resume',
  name: 'Streak',
  description: 'This is Streak',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Streak-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Streak-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Stellar = {
  type: 'Resume',
  name: 'Stellar',
  description: 'This is Stellar',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Stellar-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Stellar-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};

export const Inventor = {
  type: 'Resume',
  name: 'Inventor',
  description: 'This is inventor',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Inventor-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Inventor-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, IMAGES],
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};

export const Nineties = {
  type: 'Resume',
  name: 'Nineties',
  description: 'Classic version of modern designs',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Nineties-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Nineties-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [MULTI_COLUMN, SKILL_RATINGS, IMAGES],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#F2994A',
      text: 'Ratings Incl.',
    },
  ],
};

export const Simple = {
  type: 'Resume',
  name: 'Simple',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Simple-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Simple-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Functional = {
  type: 'Resume',
  name: 'Functional',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Functional-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Functional-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN],
  isATSFriendly: true,
  isSupportDocx: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: white,
      bgColor: msWordChipBG,
      text: 'MS Word.',
    },
    {
      color: Black,
      bgColor: atsChipBG,
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Businessmajor = {
  type: 'Resume',
  name: 'Businessmajor',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Business major-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Business major-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Agricultural = {
  type: 'Resume',
  name: 'Agricultural',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Agricultural-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Agricultural-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN],
  isATSFriendly: true,
  isSupportDocx: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: white,
      bgColor: msWordChipBG,
      text: 'MS Word.',
    },
    {
      color: Black,
      bgColor: atsChipBG,
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Geospatial = {
  type: 'Resume',
  name: 'Geospatial',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Geospatial-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Geospatial-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN],
  isATSFriendly: true,
  isSupportDocx: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: white,
      bgColor: msWordChipBG,
      text: 'MS Word.',
    },
    {
      color: Black,
      bgColor: atsChipBG,
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};

export const Vintage = {
  type: 'Resume',
  name: 'Vintage',
  description: 'Perfectly spaced and nifty resume without clutter',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Vintage-gallery_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Vintage-gallery_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN],
  isATSFriendly: true,
  isSupportDocx: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: white,
      bgColor: msWordChipBG,
      text: 'MS Word.',
    },
    {
      color: Black,
      bgColor: atsChipBG,
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};
export const Classic = {
  type: 'Resume',
  name: 'Classic',
  description: 'Simple resume, more information, yet not-clumsy',
  fullName: {
    textCase: 'uppercase',
  },
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/Classic-Resume_page-0001-min.jpg',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/Classic-Resume_page-0001-min.jpg',
  typeKey: 'resumeType',
  accessType: 'premium',
  formatType: [FormatTypes.RESUME],
  to: '/drive/myDrive',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  isATSFriendly: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: '#FFFFFF',
      bgColor: '#2B57A8',
      text: 'MS Word.',
    },
    {
      color: '#000',
      bgColor: '#E0FFD8',
      text: 'ATS_Friendly',
      bold: true,
    },
  ],
};

export const resumeTemplates = {
  Attractive,
  Basic,
  Elegant,
  Emblem,
  Exemplary,
  Gradient,
  Falcon,
  Techie,
  Inventor,
  Nineties,
  Simple,
  Vintage,
  Stellar,
  Orion,
  Businessmajor,
  Agricultural,
  Functional,
  Geospatial,
  Proxima,
  Streak,
  Classic,
};

export const defaultTemplate = Attractive;

export default [
  Attractive,
  Basic,
  Elegant,
  Emblem,
  Exemplary,
  Gradient,
  Falcon,
  Techie,
  Inventor,
  Nineties,
  Simple,
  Vintage,
  Stellar,
  Orion,
  Businessmajor,
  Agricultural,
  Functional,
  Geospatial,
  Proxima,
  Streak,
  Classic,
];
